<template>
  <div class="gold" v-if="goldStatus">
    <div class="gold_bg" @click="close_gold()"></div>
    <div class="gold_box">
      <div class="goldclose">
        <img
          class="goldclose_img"
          :src="require('@/img/' + getTheme + '-close.png')"
          @click="close_gold()"
        />
        <!-- <img
          class="goldclose_img"
          src="@/img/kpclose.png"
          alt
          @click="close_gold()"
          v-if="getTheme == 1"
        />
        <img
          class="goldclose_img"
          src="@/img/colse.png"
          alt
          v-else
          @click="close_gold()"
        /> -->
      </div>
      <div class="gold_Url">
        <img class="gold_img" src="@/img/coin.png" alt />
      </div>
      <div class="gold_title">{{ $t("goldModal.conversiongold") }}</div>
      <div class="gold_ratio">
        {{ price.diamondPrice }} {{ $t("goldModal.diamond") }} =
        {{ price.goldPrice }} {{ $t("goldModal.gold") }}
      </div>
      <!-- 购买数量 -->
      <div class="gold_sum_box">
        <div class="gold_frame">
          <div
            class="gold_subtract"
            @click="subtract()"
            @touchstart="touchsubtract()"
            @touchend="clearsubtract()"
          >
            -
          </div>
          <div class="gold_sum">
            <input
              class="gold_input"
              type="number"
              v-model="goldsum"
              @keyup="changeNumber"
            />
          </div>
          <div
            class="gold_add"
            @click="add()"
            @touchstart="touchadd()"
            @touchend="clearadd()"
          >
            +
          </div>
        </div>
        <div class="gold_sum_max" @click="addmax()">
          {{ $t("goldModal.MAX") }}
        </div>
      </div>
      <div
        v-if="goldsum != '' && goldsum != 0"
        class="gold_botton"
        @click="onPay"
      >
        {{ $t("goldModal.Pay") }} {{ goldsum * price.goldPrice }}
        {{ $t("goldModal.gold") }}
      </div>
      <div v-else class="gold_botton_active">
        {{ $t("goldModal.Pay") }} {{ goldsum * price.goldPrice }}
        {{ $t("goldModal.gold") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
export default {
  props: ["goldStatus"],
  data() {
    return {
      goldsum: 0,
      item: "",
      itemadd: "",
      price: {},
      getTheme: ""
    };
  },
  computed: {
    ...mapState("pay", ["gold", "balance"])
  },
  created() {
    this.getTheme = configs.getTheme();
  },
  mounted() {
    this.CoinPrice();
  },
  methods: {
    ...mapActions("pay", ["getCoinPrice", "getCoinChange", "Coin"]),
    ...mapActions("user", ["tipMessage"]),
    getCoin() {
      this.Coin({
        $axios: this.$axios,
        appId: configs.bipAppId()
      });
    },

    // 获取兑换金币的比例
    async CoinPrice() {
      const res = await this.getCoinPrice({
        $axios: this.$axios,
        appId: configs.bipAppId()
      });
      if (res) {
        this.price = res;
      }
    },

    close_gold() {
      this.$emit("setGoldStatus", false);
    },
    async onPay() {
      if (this.goldsum > 0) {
        let res = await this.getCoinChange({
          $axios: this.$axios,
          cnt: +this.goldsum,
          appId: configs.bipAppId()
        });
        this.close_gold();
        if (res.stateCode == 1) {
          this.getCoin();
          this.tipMessage({
            context: this.$t("index.success")
          });
        } else {
          this.tipMessage({
            context: this.$t("Code.else")
          });
          // this.tipMessage({
          // 	context: this.$t(`Code[${result.Error}]`).indexOf('Code[') == -1 ? this.$t(`Code[${result.Error}]`) : this.$t(`Code.else`)
          // });
        }
      }
    },
    //点击计算属性
    subtract() {
      var self = this;
      if (self.goldsum == 0) {
        return;
      }
      if (self.goldsum == 1) {
        self.goldsum = 1;
      } else {
        self.goldsum = self.goldsum - 1;
      }
    },

    // touchsubtract 长按减肥
    touchsubtract(e) {
      var self = this;
      self.item = setInterval(function() {
        if (self.goldsum == 0) {
          self.goldsum = 0;
          clearInterval(self.item);
        } else {
          self.goldsum = self.goldsum - 1;
        }
      }, 100);
    },
    // 清除减号定时器
    clearsubtract() {
      var self = this;
      clearInterval(self.item);
    },

    // 点击加号
    add() {
      var self = this;
      if (self.goldsum >= this.balance) {
        self.goldsum = this.balance;
      } else {
        self.goldsum = self.goldsum + 1;
      }
    },
    // 长按添加
    touchadd() {
      var self = this;
      self.itemadd = setInterval(function() {
        if (self.goldsum >= self.balance) {
          self.goldsum = self.balance;
          clearInterval(self.itemadd);
        } else {
          self.goldsum = Number(self.goldsum) + 1;
        }
      }, 100);
    },
    // 清除加号定时器
    clearadd() {
      var self = this;
      clearInterval(self.itemadd);
    },
    addmax() {
      // 点击，max
      this.goldsum = this.balance;
    },
    changeNumber() {
      let str = "" + this.goldsum;
      if (this.goldsum >= this.balance) {
        this.goldsum = this.balance;
        return;
      }
      if (str.indexOf(".") != -1) {
        let arr = str.split("");
        arr.splice(arr.length - 1);
        let str2 = arr.join("");
        this.goldsum = +str2;
      } else if (str[0] == 0) {
        let arr = str.split("");
        arr.splice(0, 1);
        let str2 = arr.join("");
        this.goldsum = +str2;
      }
    }
  }
};
</script>

<style scoped="scoped">
.gold {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gold_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
}
.gold_box {
  width: 9.48rem;
  /* height: 6rem; */
  background-color: var(--coinModelBg);
  border-radius: 0.6rem;
  position: relative;
  z-index: 2;
  padding-top: 1.14rem;
  padding-bottom: 0.79rem;
}
.goldclose {
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.28rem 0.21rem 0 0;
  z-index: 2;
}
.goldclose_img {
  width: 0.72rem;
  height: 0.72rem;
}
.gold_Url {
  width: 100%;
  height: 2.04rem;
  display: flex;
  justify-content: center;
  position: absolute;
  top: -0.9rem;
}
.gold_img {
  margin: 0 auto;
  width: 2.04rem;
  height: 2.04rem;
}
.gold_title {
  font-size: 0.54rem;
  color: var(--coinTitleColor);
  text-align: center;
  margin-top: 0.72rem;
  font-weight: bold;
}

.gold_ratio {
  text-align: center;
  font-size: 0.36rem;
  color: #ff9c00;
  margin-top: 0.2rem;
}

.gold_sum_box {
  margin-top: 0.43rem;
  display: flex;
  justify-content: center;
}
.gold_frame {
  display: flex;
  justify-content: space-between;
  width: 4.47rem;
  height: 1.14rem;
  background-color: var(--coinInputBg);
  border-radius: 0.24rem;
  border: solid 0.02rem rgba(0, 0, 0, 0.1);
  margin-right: 0.24rem;
}

.gold_sum {
  width: 2.4rem;
  height: 1.14rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gold_input {
  width: 2.4rem;
  font-size: 0.42rem;
  height: 1.1rem;
  color: var(--coinInputColor);
  padding: 0;
  text-align: center;
}
.gold_subtract,
.gold_add {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  height: 100%;
  font-size: 0.54rem;
  color: var(--coinInputColor);
}
.gold_sum_max {
  width: 1.8rem;
  height: 1.14rem;
  background-color: var(--coinInputBg);
  border-radius: 0.24rem;
  border: solid 0.02rem rgba(0, 0, 0, 0.1);
  display: flex;
  color: var(--coinInputColor);
  justify-content: center;
  align-items: center;
}
.gold_botton {
  margin: 0.96rem auto 0;
  font-size: 0.42rem;
  color: var(--coinBtnColor);
  width: 8.16rem;
  height: 1.32rem;
  background-color: var(--coinBtnBackground);
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.61rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.05rem;
}
.gold_botton_active {
  margin: 0.96rem auto 0;
  font-size: 0.42rem;
  color: var(--coinBtnColor);
  width: 8.16rem;
  height: 1.32rem;
  background-color: #e5e5e5;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.61rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding-top: 0.02rem; */
  padding-bottom: 0.05rem;
  opacity: 0.5;
  /* line-height: 1.37rem; */
}
</style>



// WEBPACK FOOTER //
// src/components/gold/index.vue